<template>
    <div>
        <div class="wrapper" :style="getWrapperStyle">
            <div class="text" :style="getTextStyle">{{config.text}}</div>
            <div class="clock" :style="getCountDownStyle"> {{countDown}}</div>

        </div>
    </div>

</template>


<script>
    export default {
        name: 'count-down',
        props: {
            config: {},
            componentData: {},


        },
        data() {
            return {
                currentTime: new Date(),
                countDown: "00:00"
            }
        },
        computed: {

            getCountDownStyle() {
                var CSS_STRING = "font-size:" + this.config.countDownFontSize + ";"
                return CSS_STRING
            },
            getTextStyle() {
                var CSS_STRING = "font-size:" + this.config.textFontSize + ";"
                return CSS_STRING
            },
            getWrapperStyle() {
                var CSS_STRING = "color:" + this.config.wrapper.color + ";"
                CSS_STRING += "background:" + this.config.wrapper.background + ";"
                CSS_STRING += "height:" + this.config.wrapper.height + ";"
                CSS_STRING += "width:" + this.config.wrapper.width + ";"
                return CSS_STRING
            }
        },
        methods: {
            secondsToHmS(d) {
                if (d < 0) {
                    this.countDown = "00:00"
                    return
                }
                d = Number(d);
                var h = Math.floor(d / 3600);
                h = ("00" + h).substr(-2, 2)
                var m = Math.floor(d % 3600 / 60);
                m = ("00" + m).substr(-2, 2)
                // var s = Math.floor(d % 3600 % 60);

                this.countDown = h + ":" + m

            }
        },
        created() {
            this.currentTime = moment.now()
            var self = this
            setInterval(function () {
                self.currentTime = moment.now()
                self.secondsToHmS(moment(self.componentData.countdown).diff(moment.now(), 'seconds'))
            }, 1000)

        }
    }
</script>
<style lang="scss" scoped>

    .wrapper {
        height: 100%;
        font-size: 40px;
        font-weight: 700;
        .clock {
            position: absolute;
            top: 60%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: center;
            font-size: 100px;
            font-weight: 700;
            vertical-align: middle;
        }
        .text {
            position: absolute;
            top: 30%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: center;
            font-size: 80px;
            font-weight: 700;
            vertical-align: middle;
        }
    }
</style>